import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from '../shared/services/http.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss', '../../assets/form.scss'],
})
export class FooterComponent implements OnInit {
  constructor(private httpService: HttpService, private router: Router) {}

  ngOnInit(): void {}

  submit(form: NgForm) {
    if (form.invalid) {
      return;
    }

    const { nameFamily, email, message } = form.value;
    const _subject = `${form.value.nameFamily}`;
    const body = `<p style=""direction: rtl;"">
    نام و نام خانوادگی: ${nameFamily} </p><p style=""direction: rtl;"">
     آدرس ایمیل: ${email}
    </p><p style=""direction: rtl;"">
    شرح: ${message}
    </p>`;

    const formData = new FormData();
    formData.append('From', email);
    formData.append('Subject', _subject);
    formData.append('UserName', nameFamily);
    formData.append('Body', body);

    this.httpService.postData(
      formData,
      'https://app.aban.capital/MailPublic.php'
    );
  }
}
